import { render } from "./Cookie.vue?vue&type=template&id=4b683852&scoped=true"
const script = {}

import "./Cookie.vue?vue&type=style&index=0&id=4b683852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b683852"]])

export default __exports__